import * as $ from 'jquery';
import {UIElement} from "./ui";
import '/modules/common/css/ui/tooltip.css'
import '/modules/common/css/ui/tooltip.mobile.css'

/**
 * A tooltip to make the behaviour of the "title" attribute predictable across browsers and devices
 * A tooltip will be shown when there is a title attribute with text and on the following conditions:
 * . If mobile, on touch and hold the element for at least 500ms
 * . If desktop, on hover the element
 * @extends UIElement
 */
class Tooltip extends UIElement {

    /**
     * @param id {string} A unique id for this tooltip
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param element {jQuery} The DOM application container
     */
    constructor(id, translator, isMobileDevice, element) {
        super(id, translator, isMobileDevice, undefined, undefined)
        this.target = element;

        this.uiElement = $('<div class="tumbo-tooltip"></div>').click(() => this.hide());
        this.target.append(this.uiElement);

        const ignored = ['HTMLCanvasElement'];
        const handleEvent = event => {
            const domElement = document.elementFromPoint(event.pageX, event.pageY);
            const element = $(domElement);
            if(!domElement || element.hasClass('tooltiped'))
                return;
            if (ignored.indexOf(domElement.__proto__.constructor.name) < 0
                && !$(domElement).hasClass('ol-control')
            ) {
                if (element.attr('title') && element.attr('title').length > 0
                    || element.attr('data-title') && element.attr('data-title').length > 0) {
                    this.show(element, event.clientX, event.clientY);
                } else this.hide();
            } else this.hide();
        };
        if(!isMobileDevice) {
            this.target.mousemove(handleEvent);
        } else {
            const onLongPress = callback => {
                let timer;

                this.target.on('touchstart', event => {
                    timer = setTimeout(() => {
                        timer = null;
                        callback(event.originalEvent.touches[0]);
                    }, 500);
                });

                function cancel() {
                    clearTimeout(timer);
                }

                this.target.on('touchend', cancel);
                this.target.on('touchmove', cancel);
                $(this.target).on('click', () => this.hide());
            };

            onLongPress(e => {
                this.hide();
                handleEvent(e);
            });
        }
    }

    getClassName() {
        return "Tooltip";
    }

    getCode() {
        return "tooltip";
    }

    getUIElement() {
        return this.uiElement;
    }

    /**
     * Shows a tooltip for an element on a screen position
     * Handles the problem of having a tooltip too close to the application margins
     * @param element The tooltiped element
     * @param x The X coordinate in pixels (should come from the user triggered event - hover or touch and hold)
     * @param y The Y coordinate in pixels (should come from the user triggered event - hover or touch and hold)
     */
    show(element, x, y) {
        this.tooltipedElement = element;
        const text = this.tooltipedElement.attr('title');
        this.tooltipedElement.attr('data-title', text);
        this.tooltipedElement.removeAttr('title');
        this.uiElement.html(text).show();

        const targetPosition = this.target.position();
        x-=targetPosition.left;
        y-=targetPosition.top;

        x+=this.isMobileDevice?0:10;
        y+=this.isMobileDevice?-70:10;

        const height = this.uiElement.height();
        const width = this.uiElement.width();
        const targetWidth = this.target.width()-20;
        const targetHeight = this.target.height()-20;

        const left = Math.max(targetPosition.left, Math.min(x,targetPosition.left+targetWidth-width));
        const top = Math.max(targetPosition.top, Math.min(y,targetPosition.top+targetHeight-height));

        this.uiElement.css('left', left+'px').css('top', top+'px').show();
        this.tooltipedElement.addClass('tooltiped');
        this.logStat("SHOW");
    }

    /**
     * Hides any visible tooltip
     */
    hide() {
        if (this.tooltipedElement) {
            const text = this.tooltipedElement.attr('data-title');
            this.tooltipedElement.attr('title', text);
            this.uiElement.hide();
            $('.tooltiped',this.target).removeClass('tooltiped');
        }
    }
}

export {Tooltip}